__turbopack_context__.v({
  "markdown-container": "W2tgCG_markdown-container",
});
